import React, { useEffect } from "react";

const Helmet = (props) => {
  useEffect(() => {
    // Set document title
    document.title = "United Limited Company";
    
    // Update or create description meta tag
    let descriptionTag = document.querySelector('meta[name="description"]');
    if (!descriptionTag) {
      descriptionTag = document.createElement('meta');
      descriptionTag.setAttribute('name', 'description');
      document.head.appendChild(descriptionTag);
    }
    descriptionTag.setAttribute('content', 
      'United Limited Company is a top-rated equipment rental and general contracting company in Saudi Arabia. ' +
      'Experts in Oil & Gas, construction, infrastructure, offshore support, and plant shutdowns.');
  }, []);

  return <div className="w-100">{props.children}</div>;
};

export default Helmet;